module.exports = __webpack_public_path__ + "1aa26b2be2f1faf8c75476e95f09c453.svg";